import * as yup from "yup";

export const labourTrainingSchema = yup.object().shape({
  startDate: yup.string().required("Required"),
  labourName: yup.string().required("Required"),
  clientProjectNumber: yup.string(),
  labourSchedule: yup.array(),
});
